// Siempre muestra horas en hora Colombia (UTC-5 / America/Bogota)
// Usar estas funciones en TODA la app en vez de new Date().toLocaleDateString() sin timeZone

const TZ = 'America/Bogota'

/** "15 may · 2:30 pm" */
export function fecHora(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    day: '2-digit', month: 'short',
    hour: '2-digit', minute: '2-digit',
    hour12: true,
  }).format(new Date(iso))
}

/** "15 may 2026" */
export function fecCorta(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    day: '2-digit', month: 'short', year: 'numeric',
  }).format(new Date(iso))
}

/** "15/05/2026" */
export function fecNumero(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    day: '2-digit', month: '2-digit', year: 'numeric',
  }).format(new Date(iso))
}

/** "lunes, 15 de mayo de 2026" */
export function fecLarga(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  }).format(new Date(iso))
}

/** "lun. 15 may" — para headers del sidebar */
export function fecSidebar(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    weekday: 'short', day: 'numeric', month: 'short',
  }).format(new Date(iso))
}

/** "2:30 pm" — solo hora */
export function soloHora(iso: string | Date) {
  return new Intl.DateTimeFormat('es-CO', {
    timeZone: TZ,
    hour: '2-digit', minute: '2-digit', hour12: true,
  }).format(new Date(iso))
}

/** Fecha actual en Colombia como Date object ajustado */
export function ahoraColombia() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }))
}

/** "2026-05-15" — formato ISO solo fecha, en hora Colombia */
export function isoFechaColombia(iso?: string | Date) {
  const d = iso ? new Date(iso) : new Date()
  return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(d) // en-CA da YYYY-MM-DD
}

/** Hace cuánto tiempo: "hace 5 min", "hace 2 h", "hace 3 días" */
export function tiempoRelativo(iso: string | Date) {
  const diff = Date.now() - new Date(iso).getTime()
  const min  = Math.floor(diff / 60_000)
  const h    = Math.floor(diff / 3_600_000)
  const d    = Math.floor(diff / 86_400_000)
  if (min < 1)  return 'ahora mismo'
  if (min < 60) return `hace ${min} min`
  if (h   < 24) return `hace ${h} h`
  if (d   < 7)  return `hace ${d} día${d > 1 ? 's' : ''}`
  return fecCorta(iso)
}
